import useAlarm from "./useAlarm";

export default useAlarm;